import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getWoundCareSelector } from '../selectors'
import { WoundCareConstants } from '../store/woundCare.constants'
import { IWoundCareState } from '../store/woundCare.types'

export function* setActions() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const woundCareState: IWoundCareState = yield select(getWoundCareSelector)
  const { inputRows } = procedureState
  const { actions } = woundCareState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === WoundCareConstants.SET_ACTIONS) {
        //@ts-ignore
        input.props.savedValues = actions
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setActionsSaga() {
  yield takeLatest([WoundCareConstants.SET_ACTIONS], setActions)
}
